import React from "react";
import { DataDriver } from "@rebasepro/types";

export const DataDriverContext = React.createContext<DataDriver>({} as DataDriver);
